import style from "./colors.module.scss";

const colors = [
        { name: 'Gold', color: style.secondary },
        { name: 'Blue', color: style.primary },
        { name: 'Dark Blue', color: style.darkBlue },
        { name: 'Light Blue', color: style.blueLight },
        { name: 'Black', color: style.black },
        { name: 'White', color: style.white },    
        { name: "Transparent", color: "#FFFFFF00"} 
    ];
export default colors;
